
export class TwoPointSliderContext {
    constructor() {

    }
}
